var map = {
	"./scroll.js": "UsrV",
	"./tips.js": "itp3",
	"./video.js": "UhNX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SLZf";


//////////////////
// WEBPACK FOOTER
// ./src/directives/modules \.js$
// module id = SLZf
// module chunks = 1 2